import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const purchaseSeatLanguages = {
  progressBarText:
    "Add 2 games and get 15% off, add 3 games and get 20% off, or add 5 games and get 25% off plus a $20 Cyclones gift card!",
  progressBarAditionalText: " to continue and receive 15% off your tickets!",
  similarSeatModalBody: (seatTitle: string) => (
    <>
      We are going to apply the same or similar seats to all games in your plan.
    </>
  ),
};

const BrooklynCyclonesLink = () => (
  <Link
    target="_blank"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
    href="https://mlb.tickets.com/?agency=BCYM_MYTIXX&orgid=58030"
  >
    My Tickets
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description:
      "Select the games you wish to attend. The more games you select the higher your discount.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com",
    description:
      "Click Continue and connect your email used to purchase account using our secure My Cyclones login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <BrooklynCyclonesLink /> account
        within 24 hours of purchase. Reach out to 718-37-BKLYN for any
        questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Amazin' Pick A Plan Flex Program work?",
    description: (
      <>
        The Amazin&apos; Pick A Plan Flex Program allows fans to select any seat
        to select games hosted by the Brooklyn Cyclones. Simply log into your
        Cyclones <BrooklynCyclonesLink /> Account and select games
      </>
    ),
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all currently available inventory.",
  },
  {
    title: "Where are my tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Cyclones{" "}
        <BrooklynCyclonesLink /> Account.
      </>
    ),
  },
];
